<section>

  <div class="auth-section">

  <div class="auth-box">
    <div class="row">
      <div class="col">
        <h1 style="font-size: 30px!important;" vlass=""mb-2><b>Authorise {{providerValue | replaceStatus}}</b></h1>

        <label style="font-size: 17px!important;" class="mb-4">When authorising a third party application to access selling partner data on your behalf you are responsible for all actions taken by third party in connection with your account.</label>

        <h1 style="font-size: 30px!important;">{{providerValue | replaceStatus}} requires access to view or edit your information pertaining to your:</h1>
      </div>
    </div>
    <hr>
    <div *ngFor="let acc of access;let i = index;">
  <div class="auth-list">
    <label style="font-size: 23px!important;">{{i}} {{acc}}</label>
  </div>
    <hr>
    </div>
  <div class="row">
    <div class="col" style="display : flex">
      <input type="checkbox" id="for" class="mt-1" [(ngModel)]="clickBox" [ngModelOptions]="{standalone: true}">
      <label class="ml-1">These Website Standard Terms and Conditions written on this webpage shall manage your use of our website,
        Website accessible at https://shift.in.</label>
    </div>
    <div id="clickBoxError" class="invalid-feedback d-block shift-invalid-login" [hidden]="!clickBoxError">{{clickBoxError}}</div>
  </div>
  <div class="row">
    <div class="col-12 text-right">
      <button class="btn btn-cancel">Cancel</button>
      <button class="btn btn-orange ml-3" (click)="submitAuthorize()"> Confirm</button>
    </div>
  </div>
  </div>
  </div>
</section>
